/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import GatewayBulkProvisioningController from './bulk-provisioning/bulk-provisioning.controller';
import AddGatewayController from './add-gateway.controller';
import GatewayInfoController from './gateway-info/gateway-info.controller';
import GatewayTableConfig from './gateway-table.config';
import GatewayDirective from './gateway.directive';
import GatewayRoutes from './gateway.routes';

export default angular.module('tektelic.gateway', [])
    .config(GatewayRoutes)
    .controller('AddGatewayController', AddGatewayController)
    .controller('GatewayInfoController', GatewayInfoController)
    .controller('GatewayBulkProvisioningController', GatewayBulkProvisioningController)
    .directive('tkGateway', GatewayDirective)
    .factory('gatewayTableConfig', GatewayTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/gateway/index.js